import { useId } from 'react'

export type SunnySymbolProps = {
  size?: number
  animated?: boolean
}

// A clear sun with warm, saturated edges that hold against the sidebar mesh.
export default function SunnySymbol({ size = 88, animated = false }: SunnySymbolProps) {
  const id = useId()
  const sun = `${id}-sun`
  const light = `${id}-light`

  return (
    <svg viewBox="0 0 96 96" width={size} height={size} className="shrink-0 overflow-visible" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={sun} x1="24" y1="20" x2="68" y2="78" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ffc943" />
          <stop offset="0.48" stopColor="#ffb323" />
          <stop offset="1" stopColor="#f4772a" />
        </linearGradient>
        <radialGradient id={light} cx="0.35" cy="0.2" r="0.8">
          <stop stopColor="#fff1aa" stopOpacity="0.45" />
          <stop offset="1" stopColor="#fff1aa" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g className={animated ? 'sunny-logo-sun' : undefined}>
        <g fill={`url(#${sun})`}>
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
            <rect key={angle} x="44" y="6" width="8" height="14" rx="4" transform={`rotate(${angle} 48 48)`} />
          ))}
          <circle cx="48" cy="48" r="25" />
        </g>
        <circle cx="48" cy="48" r="25" fill={`url(#${light})`} />
      </g>
    </svg>
  )
}
